import axios from 'axios';

export function HTTP(token) {
  return axios.create({
    baseURL:window.process.env.API_HOST_GLOBAL,
    headers: {
      Authorization: token,
    },
  });
}



// WEBPACK FOOTER //
// ./src/core/http/http-token.js